<template>
  <div id="sidebar-order" class="sidebar-order">
      <div class="col-md-3">
        <div class="theiaStickySidebar">
            <div id="cart_box">
                <h3>Your order <i class="icon_cart_alt pull-right"></i> </h3>
                <div v-if="cartAdded" id="cartAdded">
                  <div class="row" id="cartItems">
                  <!-- <div class="col-lg-12 extraTopping" v-for="items in this.$store.getters.orders" :key="items.id" >
                    <div style="position: absolute; right:15px; top:8px ">
                      <a href="javascript:void(0)" class="remove_item" @click.prevent="deleteMenuItem(items.menu_slug,items.menu_price,items.id,items.order_id)"><i class="fa fa-trash"></i></a>
                    </div>
                    <div>
                    <div class="cart-item">
                      <strong> {{items.menu_name}} </strong>   
                    </div>
                    <div class="cart-item" style="width:100%">
                      <span> 
                      {{items.menu_size}} - {{items.menu_qty}} x {{items.menu_price}}  <div class="pull-right">${{ (items.final_menu_price)}}</div>
                      </span>
                      <div class="clearfix"></div>
                      <span v-if="items.total_toppings_price > 0">  Toppings Price  <div class="pull-right" v-text="('$'+items.total_toppings_price)"></div></span>
                    </div>
                    </div>
                  </div> -->

                </div>  
                  <hr style="margin-bottom:5px">
                  <button class="btn btn-sm btn-danger btn-block" @click.prevent="cancelOrder(order_id)"> <span class="fa fa-trash fa-1x"></span> Cancel Order</button>
                  <hr  style="margin-top:5px">
                  <div class="row" id="options_2">
                    <div class="col-lg-12" style="margin-bottom: 10px; color: #fa4936; font-weight: 600">
                      <small id=""><p>Choose your delivery type</p></small>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-6">
                        <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input" id="pickup" @change="setDeliveryType('pickup')" value="pickup" v-bind:checked="p_checked" name="example1">
                            <label class="custom-control-label" for="pickup">Pickup</label>
                        </div> 
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-6">
                        <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input" v-bind:checked="d_checked" id="delivery" @change="setDeliveryType('delivery')" value="delivery" name="example1">
                            <label class="custom-control-label" for="delivery">Delivery</label>
                        </div> 
                    </div>
                    
                  </div>
                <hr class="margin-bottom-5 margin-top-15">
                <table class="table table_summary margin-bottom-10" style="font-size:14px">
                  <tbody>
                    <tr>
                        <td>
                            Subtotal <span class="pull-right" id="sub_total">$ {{sub_total}}</span>
                        </td>
                    </tr>
                    
                    <tr>
                        <td>
                            Delivery fee <span class="pull-right" id="delivery_amount">$ {{delivery_amount}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="total" style="font-size:14px">
                            TOTAL <span class="pull-right" id="total_amount"> $ {{total_amount}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="total" style="font-size:12px; color: tomato; text-align: right">
                            * GST Inclusive
                        </td>
                    </tr>

                </tbody>
                </table>
                <hr class="margin-bottom-15 margin-top-0">
                <div class="row" style="margin-bottom:15px">
                    <div class="col-lg-12">
                    <div class="form-group" v-if="deliverBox">
                      <h4>Delivery Address</h4>
                      <p>{{errorMessage}}</p>
                      <input type="text" class="form-control" v-model="delivery_name" placeholder="Enter name">
                      <input type="text" class="form-control" v-model="delivery_mobile" placeholder="Enter mobile number">
                      <input type="text" class="form-control" v-model="delivery_email" placeholder="Enter email address">
                      <input type="text" class="form-control" v-model="delivery_address" placeholder="Enter delivery address">
                      <input type="text" class="form-control" v-model="delivery_province" placeholder="Enter province">
                      <input type="text" class="form-control" v-model="delivery_city" placeholder="Enter city name">
                    </div>

                    <h4>Credit Card</h4>
                    <card class='stripe-card'
                      :class='{ complete }'
                      stripe='pk_test_vDLUe6OnhUuLh5zyquGPnCbP00xmgXVMrN'
                      :options='stripeOptions'
                      @change='complete = $event.complete'
                    />
                    <a class="btn_full pay-with-stripe" :disabled='!complete' href="javascript:void(0)" @click.prevent="orderNow(orders[0].order_id)">Order now</a>
                    </div>
                </div>
                </div>
                <div v-else>
                  <div id="empty-cart">
                  <p><img src="/img/empty-cart.jpg" class="img-responsive" alt=""/></p>
                  <h4 align="center" style="font-family: 'Righteous', cursive">Your Cart is Empty</h4>
                  <h5 align="center" style="line-height:20px;">Looks like you haven't added anything to your cart yet.</h5>
                  </div>
                  <!-- <a class="btn_full" href="javascript:void(0)" >Empty Cart</a> -->
                </div> 
                
                <div align="center" style="font-weight: 600; margin-top: 10px" v-if="deliverBox">
                  <hr>
                  <p>{{ (this.settings.length > 0) ? this.settings[2].meta_value : ''}}</p>
                </div>
                <div align="center" style="font-weight: 600; margin-top: 10px" v-else>
                  <hr>
                  <p>{{ (this.settings.length > 0) ? this.settings[1].meta_value : ''}} </p> 
                </div>
            </div>
        </div>
    </div>
  </div>  
</template>

<script>
import { Card, createToken } from 'vue-stripe-elements-plus'
import { mapGetters } from 'vuex';
import * as render from '../utils/render'
export default {
  name: 'Order',
  data() {
      return {
          shouldStick: true,
          complete: false,
          delivery_name:'',
          delivery_mobile:'',
          delivery_email: '',
          delivery_province:'',
          delivery_city:'',
          delivery_address: '',
          errorMessage: null,
          stripeOptions: {
            hidePostalCode: true,
            // see https://stripe.com/docs/stripe.js#element-options for details
          }
      }
  },
  components: { Card, createToken },
  updated() {
        this.$store.watch( getters => getters.cartAdded),
        this.$store.watch( getters => getters.orders),
        this.$store.watch( getters => getters.order_id),
        this.$store.watch( getters => getters.delivery_amount),
        this.$store.watch( getters => getters.deleveryType),
        this.$store.watch( getters => getters.isLoggedIn),
        this.$store.watch( getters => getters.d_checked),
        this.$store.watch( getters => getters.p_checked),
        this.$store.watch( getters => getters.deliverBox ),
        this.$store.watch( getters => getters.orderPlaced),
        this.$store.watch( getters => getters.settings),
        this.$store.dispatch('getCartItem').then( (orders,order_total) => {
            render.cartItem(orders);
            if(order_total){
              render.subTotal(order_total.sub_total)
              render.deliveryAmount(order_total.delivery_amount)
              render.totalAmount(order_total.total_amount)
            }
            orders.forEach(items => {
              let button = "#menuItem_"+items.id
              $(document).on('click', button, () =>{
                this.deleteMenuItem(items.menu_slug,items.menu_price,items.id,items.order_id);
              })
            });
        });
  },
  mounted: function() {
    setTimeout( () => {
          this.getDefaultAddress();
      },1000);
  },
  computed: {
      ...mapGetters({
          orders: 'orders',
          sub_total: 'sub_total',
          order_id: 'order_id',
          delivery_amount: 'delivery_amount',
          total_amount: 'total_amount',
          cartAdded: 'cartAdded',
          deleveryType: 'deleveryType',
          d_checked: 'd_checked',
          p_checked: 'p_checked',
          cartToppings: 'cartToppings',
          auth: 'auth',
          isLoggedIn: 'isLoggedIn',
          deliverBox: 'deliverBox',
          orderPlaced: 'orderPlaced',
          settings: 'settings'
      })
  },
  methods:{
      cancelOrder(order_id){
        Swal.fire({
          title: 'Are you sure?',
          text: "Once deleted, you will not be able to order this menu items?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            let user_key = sessionStorage.getItem('user_key')
            let payload = { order_id : order_id , user_key: user_key};
            this.$store.dispatch('cancelOrder', payload).then( success => {
              this.$fire({
                html: "<b>Order have been deleted</b>",
                type: "success",
                timer: 2000
              });
              this.cart = false
              $(".topping_class").css({'display':'none'});
              $(".collapsed_open").css({'display':'inline-block'});
              $(".collapsed_close").css({'display':'none'});
            }).catch(err => {
              console.log(err);
            });
          }
        })
      },
      deleteMenuItem(s,p, menu_id, order_id){
          let user_key = sessionStorage.getItem('user_key')
          let data = { user_key:user_key, menu_slug: s , menu_price: p , menu_id: menu_id, order_id: order_id }
          this.$store.dispatch('deleteOrderMenuItem', data).then( (orders,order_total) => {
            render.cartItem(orders);
            if(order_total){
              
              render.subTotal(order_total.sub_total)
              render.deliveryAmount(order_total.delivery_amount)
              render.totalAmount(order_total.total_amount)
            }
          });
      },
      setDeliveryType(type){
        this.$store.dispatch('updateDeliveryType', type).then(order_total => {
            render.subTotal(order_total.sub_total)
            render.deliveryAmount(order_total.delivery_amount)
            render.totalAmount(order_total.total_amount)
        })
        if(type == "delivery") {
          this.getDefaultAddress();
        }
      },
      getDefaultAddress() {
        let user_key = sessionStorage.getItem('user_key')
        if(user_key){
            this.$store.dispatch('userDeliveryAddress',{user_key: user_key}).then( response => {
                let data = response.data
                this.delivery_name = data.name
                this.delivery_mobile = data.mobile
                this.delivery_email = data.email
                this.delivery_address = data.delivery_address
                this.delivery_province = data.province
                this.delivery_city = data.city_name    
            })
        }
      },
      orderNow(order_id){
        // console.log("order " + this.deliverBox)
        let isLoggedIn = this.isLoggedIn  
        let user_key = sessionStorage.getItem('user_key')
        if(isLoggedIn === false){
          $("#register").modal('show');
          this.$store.dispatch('openPopup', 'login')
        }else{
            if(this.deliverBox === true){
               if(this.delivery_name === ""){
                 this.errorMessage = 'please enter name';
                 setTimeout(() => {
                  this.errorMessage = '';  
                 }, 1500);
               }else if(this.delivery_mobile === ""){
                 this.errorMessage = 'please enter mobile no';
                 setTimeout(() => {
                  this.errorMessage = '';  
                 }, 1500);
               }else if(this.delivery_email === ""){
                 this.errorMessage = 'please enter email address';
                 setTimeout(() => {
                  this.errorMessage = '';  
                 }, 1500);
               }else if(this.delivery_address === ""){
                 this.errorMessage = 'please enter delivery address';
                 setTimeout(() => {
                  this.errorMessage = '';  
                 }, 1500);
               }else if(this.delivery_province === ""){
                 this.errorMessage = 'please enter province';
                 setTimeout(() => {
                  this.errorMessage = '';  
                 }, 1500);
               }else if(this.delivery_city === ""){
                 this.errorMessage = 'please enter city name';
                 setTimeout(() => {
                  this.errorMessage = '';  
                 }, 1500);
               }else{
                 createToken().then(data => {
                    this.$store.dispatch("placeOrder", {
                      user_key: user_key,
                      delivery_address: this.delivery_address,
                      delivery_name: this.delivery_name,
                      delivery_mobile: this.delivery_mobile,
                      delivery_email: this.delivery_email,
                      delivery_province: this.delivery_province,
                      delivery_city: this.delivery_city,
                      token: data.token.id,
                      order_id: order_id
                    }).then( response => {
                      // alert(response);
                      if(response.status == 200) {
                        this.$fire({
                          title: "Orders",
                          text: "Your order placed successfully",
                          type: "success",
                          timer: 3000
                        }).then(r => {
                          this.$router.push('/profile')
                          console.log(r.value);
                        });
                      }
                      else {
                        this.$fire({
                          title: "Session Expired!",
                          text: response.message,
                          type: "error",
                          timer: 3000
                        }).then(r => {
                          window.location.reload();
                          console.log(r.value);
                        });
                      }                      
                  });
                }).catch(err => {
                  console.log("err " + err)
                })
               }
            }else{
               createToken().then(data => {
                    this.$store.dispatch("placeOrder", {
                      user_key: user_key,
                      delivery_address: this.delivery_address,
                      delivery_name: this.delivery_name,
                      delivery_mobile: this.delivery_mobile,
                      delivery_email: this.delivery_email,
                      delivery_province: this.delivery_province,
                      delivery_city: this.delivery_city,
                      token: data.token.id,
                      order_id: order_id
                    }).then(response => {
                      // alert(response.message);                      
                      if(response.status == 200) {
                        this.$fire({
                          title: "Orders",
                          text: "Your order placed successfully",
                          type: "success",
                          timer: 3000
                        }).then(r => {
                          this.$router.push('/profile')
                          console.log(r.value);
                        });
                      }
                      else {
                        this.$fire({
                          title: "Session Expired!",
                          text: response.message,
                          type: "error",
                          timer: 3000
                        }).then(r => {
                          window.location.reload();
                          console.log(r.value);
                        });
                      }
                  });
                }).catch(err => {
                  console.log("err " + err)
                }) 
            }
            
        }
      },
      defaultToppingsQty(s,i){
          if($("input[name="+s+"]:checked").length > 0){
          let qty = $("#"+s+'_ct_qty_'+i).val();
          $("#"+s+'_ct_price_'+i).text();
          let total_pizza_price = $("#"+s+'_pizza_price').text();
          if(qty == 1){
            var amount = 0.00;
            let minusPrice = 2.00;
            let finalPrice = parseFloat(total_pizza_price)-parseFloat(minusPrice);
            $("#"+s+'_pizza_price').text(finalPrice.toFixed(2));
            setTimeout(() => {
              let TotalPrice = $("#"+s+'_pizza_price').text();
              let addedToppingsItem = {"menuName": s,"etopp_id": i,"pizza_total": TotalPrice}
              this.$store.dispatch('removeDefaultToppings', addedToppingsItem)
            },2000);
          }else{
            var amount = 2.00;
            let finalPrice = parseFloat(total_pizza_price)+parseFloat(amount);
            $("#"+s+'_pizza_price').text(finalPrice.toFixed(2));
            setTimeout(() => {
              let CTName = $("#"+s+'_ct_topping_name_'+i).text();
              let CTQty = $("#"+s+'_ct_qty_'+i).val();
              let CTPrice = $("#"+s+'_ct_price_'+i).text();
              let TotalPrice = $("#"+s+'_pizza_price').text();
              let addedToppingsItem = {"menuName": s,"etopp_id": i,"pizza_total": TotalPrice,"etopp_name": CTName,"etopp_qty": CTQty , "etopp_price" : CTPrice}
              this.$store.dispatch('addDefaultToppings', addedToppingsItem)
            },2000);

          }
          $("#"+s+'_ct_price_'+i).text(amount.toFixed(2));
        }else{
          alert("please select pizza size and quantity");
          $('#'+s+'_ct_qty_'+i).prop('selectedIndex',0);
          return false;
        }
      
      },
      removeCurrentToppings(s,i){ 
        if($("input[name="+s+"]:checked").length > 0){
            if($('#'+s+'_ct_qty_'+i).val() == 2){
              $('#'+s+'_ct_qty_'+i).prop('selectedIndex',0);
              $('#'+s+'_ct_price_'+i).text('0.00');
              let total_pizza_price = $("#"+s+'_pizza_price').text();
              let minusPrice = 2.00;
              let finalPrice = parseFloat(total_pizza_price)-parseFloat(minusPrice);
              $("#"+s+'_pizza_price').text(finalPrice.toFixed(2));
              setTimeout(() => {
                let TotalPrice = $("#"+s+'_pizza_price').text();
                let addedToppingsItem = {"menuName": s,"etopp_id": i,"pizza_total": TotalPrice}
                this.$store.dispatch('removeDefaultToppings', addedToppingsItem)
              },2000);
            }
        }else{
          alert("please select size and quantity");
          return false;
          $('#'+s+'_ct_qty_'+i).prop('selectedIndex',0);
        }
      }
  },
  beforeUpdate() {
    if(this.deleveryType === 'pickup'){
      $("#pickup").prop('checked', true);
      $("#delivery").prop('checked', false);
    }else{
      $("#pickup").prop('checked', false);
      $("#delivery").prop('checked', true);
    }
  },
}
</script>
<style scoped>
.custom-checkbox input[type=checkbox] {
	opacity: 0;
	position: absolute;
	margin: 5px 0 0 3px;
	z-index: 9
}

.custom-checkbox label:before {
	width: 1.2em;
	height: 1.2em;
	content: '';
	margin-right: 10px;
	display: inline-block;
	vertical-align: text-top;
	background: #fff;
	border: 1px solid #3e3e3e;
	border-radius: 2px;
	box-sizing: border-box;
	z-index: 2
}

.custom-checkbox input[type=checkbox]:checked+label:after {
	content: '';
	position: absolute;
	left: 6px;
	top: 2px;
	width: 6px;
	height: 11px;
	border: solid #3e3e3e;
	border-width: 0 3px 3px 0;
	transform: inherit;
	z-index: 3;
	transform: rotateZ(45deg)
}


.custom-checkbox input[type=checkbox]:checked+label:before {
	border-color: #0098D7;
	background: #0098D7
}

.custom-checkbox input[type=checkbox]:checked+label:after {
	border-color: #fff
}

.custom-checkbox input[type=checkbox]:disabled+label:before {
	color: #3e3e3e;
	cursor: auto;
	box-shadow: none;
	background: #ddd
}

.custom-radio [type=radio]:checked,
.custom-radio [type=radio]:not(:checked) {
	position: absolute;
	left: -9999px
}

.custom-radio [type=radio]:checked+label,
.custom-radio [type=radio]:not(:checked)+label {
	position: relative;
	padding-left: 28px;
	cursor: pointer;
	line-height: 20px;
	display: inline-block;
	width: auto;
	height: 9px
}

.custom-radio [type=radio]:checked+label:before,
.custom-radio [type=radio]:not(:checked)+label:before {
	content: '';
	position: absolute;
	left: 0;
	top: 0;
	width: 18px;
	height: 18px;
	border: 1px solid #c3cbd5;
	border-radius: 100%;
	background: #fff
}
p{ margin-bottom: 2px}
.custom-radio [type=radio]:checked+label:after,
.custom-radio [type=radio]:not(:checked)+label:after {
	content: '';
	width: 10px;
	height: 10px;
	background: #fa4936;
	position: absolute;
	top: 4px;
	left: 4px;
	border-radius: 100%;
	-webkit-transition: all .2s ease;
	transition: all .2s ease
}
.custom-radio [type=radio]:not(:checked)+label:after {
	opacity: 0;
	-webkit-transform: scale(0);
	transform: scale(0)
}

.custom-radio [type=radio]:checked+label:after {
	opacity: 1;
	-webkit-transform: scale(1);
	transform: scale(1)
}
.extraTopping{
    border: 1px solid #ceccccf7;
    border-radius: 4px;
    margin: 5px 0px 0px 0px;
    padding-bottom: 5px;
    padding-right: 15px;
    margin: 3px 5px 0;
    width: 96%;
    position: relative;
    box-shadow: 1px 1px 2px 2px #d2d1d1ad;
}
.topp{
  padding: 0px 5px 0px 25px;
  font-size: 13px;
  font-weight: 400;
}
.cart-item{
  padding:4px 0px;width: 71%;font-size: 13px;
}
.cart-item-right{
  padding: 0px;width: 20%;font-size: 13px;float: right;
}
.custom-control-label,.table_summary{
  font-size: 13px !important;
}
/* .sidebar-order{
  position: -webkit-sticky;
  position: sticky;
  top: 60;
} */

.stripe-card {
  border: 1px solid grey;
  margin-bottom: 15px;
  padding:10px;
}
.stripe-card.complete {
  border-color: green;
}
.form-control{
  border: 1px solid grey;
  border-radius: 0;
  margin-bottom: 3px;
}
</style>
